export default function StepNames(props:{name:string}) {
    return(
        <span className="font-normal text-[77%]">
            {props.name}
        </span>
    )
}
